// extracted by mini-css-extract-plugin
export default {"container":"ModalNotificaciones_container__in04a","title":"ModalNotificaciones_title__KQHkH"};